/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentWithSchedulesResponse } from './search-equipment-with-schedules-response';


export interface SearchEquipmentWithSchedulesResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentWithSchedulesResponse> | null;
}

